import styled from 'styled-components'

export const UsdcPerpetualContent = styled.div``
